<template>
  <div :class="['navigator', skin]">
    <div
      :class="['navigator--item', animationClass]"
      @click="hasArrow ? decrement() : null"
    >
      <svgicon
        v-if=" hasArrow"
        :class="['icon', 'prev']"
        name="arrow-left"
        color="var(--ui-white)"
        height="1.625rem"
        width="1.625rem"
      />
      {{ prevLabel  }}
    </div>
    <div
      :class="['navigator--item', animationClass]"
      @click="hasArrow ? increment() : null"
    >
      {{ next && $tvaMq !== "mobile" && $tvaMq !== "tablet" ? nextLabel : "" }}
      <svgicon
        v-if="next && hasArrow"
        :class="['icon', 'next']"
        name="arrow-right"
        color="var(--ui-white)"
        height="1.625rem"
        width="1.625rem"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    skin: {
      type: String,
      default: "name",
    },
    prev: {
      type: Object,
      required: false,
    },
    next: {
      type: Object,
      required: false,
    },
    animationClass: {
      type: String,
      required: false,
    },
    myIndex: {
      type: Number,
      required: false,
    },
  },
  computed: {
    hasArrow() {
      return this.skin === "arrows";
    },
    nextLabel() {
      if (this.hasArrow) {
        return "Next";
      } else {
        return this.next.name;
      }
    },
    prevLabel() {
      if (this.hasArrow) {
        return "Prev";
      } else {
        return this.prev.name;
      }
    },
  },

  data() {
    return {};
  },
  methods: {
    ...mapActions({
      increment: "scroller/increment",
      decrement: "scroller/decrement",
    }),
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 $landing-margin-right-left;

  @include title-H3;

  &--item {
    width: toRem(200);
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:last-of-type {
      justify-content: flex-end;
    }

    .arrows & {
      width: fit-content;

      .icon {
        transition: transform 0.5s ease;
      }
      &:hover {
        .icon.prev {
          transform: translateX(-5px);
        }
        .icon.next {
          transform: translateX(5px);
        }
      }
    }
  }

  &.arrows {
    cursor: pointer;
    @include title-H6;
    text-transform: uppercase;
    padding: 0 calc($landing-margin-right-left - toRem(8));
  }
}
</style>
